import React from "react";
import profile from "../assets/Images/profile.jpg";

const About = () => {
  return (
    <div className="font-sans bg-white text-gray-800">
      {/* HERO */}
      <header className="bg-gradient-to-b from-[#162456] to-[#162456]/90 text-white">
        <div className="max-w-7xl mx-auto px-6 md:px-8 py-20 md:py-28 flex flex-col-reverse md:flex-row items-center gap-12">
          <div className="md:w-7/12 text-center md:text-left">
            <h1 className="text-3xl md:text-5xl font-extrabold leading-tight">
              Master Chemistry for IIT JAM, JEE, GATE, NEET & NET
            </h1>
            <p className="mt-4 text-lg md:text-xl max-w-3xl opacity-90">
              Learn from IIT Kanpur mentors with years of coaching experience.
              Comprehensive coverage, personalized guidance, and proven
              strategies to crack your exam.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-4 sm:items-center sm:justify-start">
              <a
                href="#courses"
                className="inline-block bg-yellow-100 text-[#162456] font-semibold px-6 py-3 rounded-lg shadow-md hover:scale-[1.01] transform transition"
              >
                Explore Courses
              </a>
              <a
                href="#contact"
                className="inline-block border-2 border-yellow-100 text-white px-6 py-3 rounded-lg hover:bg-yellow-300/10 transition"
              >
                Book a Free Trial
              </a>
            </div>

            {/* trust badges */}
            <div className="mt-8 flex flex-wrap gap-4">
              <div className="bg-white/6 backdrop-blur-sm p-3 rounded-lg text-sm md:text-base inline-flex items-center gap-3">
                <span className="inline-block w-9 h-9 rounded-full bg-white/10 flex items-center justify-center">
                  🏆
                </span>
                <div>
                  <div className="text-xs opacity-80">Mentors from</div>
                  <div className="font-semibold">IIT Kanpur</div>
                </div>
              </div>

              <div className="bg-white/6 backdrop-blur-sm p-3 rounded-lg text-sm md:text-base inline-flex items-center gap-3">
                <span className="inline-block w-9 h-9 rounded-full bg-white/10 flex items-center justify-center">
                  📚
                </span>
                <div>
                  <div className="text-xs opacity-80">Focused</div>
                  <div className="font-semibold">Exam-oriented syllabus</div>
                </div>
              </div>
            </div>
          </div>

          {/* Hero Illustration / Photo */}
          <div className="md:w-5/12 flex justify-center">
            <div className="w-80 h-80 rounded-2xl shadow-2xl border-4 border-yellow-100 overflow-hidden bg-gradient-to-tr from-white/5 to-white/3 flex items-center justify-center">
              {/* Replace with mentor / academy image */}
              <img
                src="/path/to/hero-illustration.jpg"
                alt="Machine Academy"
                className="object-cover w-full h-full"
              />
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-6 md:px-8 -mt-12 relative z-10">
        {/* Founder / Mentor Card */}
        <section className="bg-white rounded-2xl shadow-xl p-6 md:p-10 grid md:grid-cols-3 gap-8 items-center">
          <div className="col-span-1 flex justify-center md:justify-start">
            <div className="w-60 h-68 rounded-xl overflow-hidden border-4 border-[#162456] shadow-md">
              <img
                src={profile}
                alt="Mr. Sourabh Patidar"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="md:col-span-2">
            <h3 className="text-2xl font-bold text-[#162456]">
              Mr. Sourabh Patidar
            </h3>
            <p className="mt-1 font-medium text-[#162456]/80">
              Chemistry Expert
            </p>

            <p className="mt-4 text-gray-700 leading-relaxed">
              IIT Kanpur student and Founder of Machine Academy. With over 5+
              years of expertise in chemistry, Mr. Sourabh Patidar has trained
              20+ aspirants for competitive exams. He focuses on conceptual
              clarity and fast problem-solving techniques.
            </p>

            <div className="mt-6 flex flex-col sm:flex-row gap-4">
              <div className="flex items-center gap-3 bg-yellow-300/10 border border-yellow-100 rounded-lg px-4 py-3">
                <span className="text-[#162456] font-bold">✓</span>
                <div>
                  <div className="text-sm text-gray-600">Experience</div>
                  <div className="font-semibold text-[#162456]">5+ years</div>
                </div>
              </div>

              <div className="flex items-center gap-3 bg-yellow-300/10 border border-yellow-100 rounded-lg px-4 py-3">
                <span className="text-[#162456] font-bold">✓</span>
                <div>
                  <div className="text-sm text-gray-600">Aspirants Trained</div>
                  <div className="font-semibold text-[#162456]">
                    20+ students
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Why Machine Academy / Features */}
        <section className="mt-10 grid lg:grid-cols-3 gap-8">
          <div className="rounded-2xl p-8 shadow-lg bg-white">
            <h4 className="text-xl font-bold text-[#162456]">
              Why Machine Academy?
            </h4>
            <p className="mt-3 text-gray-600">
              Focused exam strategy, small batches, regular tests, doubt
              sessions, and personalized mentorship — everything tailored to
              competitive exams.
            </p>

            <ul className="mt-6 space-y-3">
              <li className="flex items-start gap-3">
                <span className="mt-1 text-yellow-100">●</span>
                <div>
                  <div className="font-semibold text-[#162456]">
                    Exam-focused syllabus
                  </div>
                  <div className="text-sm text-gray-600">
                    Strictly aligned to JAM / JEE / GATE / NEET / NET patterns
                  </div>
                </div>
              </li>

              <li className="flex items-start gap-3">
                <span className="mt-1 text-yellow-100">●</span>
                <div>
                  <div className="font-semibold text-[#162456]">
                    Live doubt clearing
                  </div>
                  <div className="text-sm text-gray-600">
                    Weekly sessions + on-demand help
                  </div>
                </div>
              </li>

              <li className="flex items-start gap-3">
                <span className="mt-1 text-yellow-100">●</span>
                <div>
                  <div className="font-semibold text-[#162456]">
                    Practice & Tests
                  </div>
                  <div className="text-sm text-gray-600">
                    Timed tests with analytics
                  </div>
                </div>
              </li>
            </ul>
          </div>

          {/* Courses Snapshot */}
          <div className="rounded-2xl p-8 shadow-lg bg-white">
            <h4 className="text-xl font-bold text-[#162456]">
              Courses Snapshot
            </h4>
            <p className="mt-3 text-gray-600">
              Short courses and full syllabus packages for IIT JAM, JEE
              (Chemistry), GATE, NEET (chemistry portion) and NET.
            </p>

            <div id="courses" className="mt-6 grid gap-4">
              {[
                { title: "IIT JAM (Complete)", duration: "6 months" },
                { title: "JEE Organic+Inorganic Booster", duration: "8 weeks" },
                { title: "GATE Crash + Revision", duration: "2 months" },
              ].map((c) => (
                <div
                  key={c.title}
                  className="flex items-center justify-between p-4 border rounded-lg"
                >
                  <div>
                    <div className="font-semibold text-[#162456]">
                      {c.title}
                    </div>
                    <div className="text-sm text-gray-600">{c.duration}</div>
                  </div>
                  <a className="text-sm font-semibold bg-yellow-100 px-3 py-2 rounded-md text-[#162456]">
                    View
                  </a>
                </div>
              ))}
            </div>
          </div>

          {/* Stats */}
          <div className="rounded-2xl p-8 shadow-lg bg-white">
            <h4 className="text-xl font-bold text-[#162456]">Our Impact</h4>
            <div className="mt-6 grid grid-cols-3 gap-4 text-center">
              <div>
                <div className="text-2xl font-extrabold text-[#162456]">5+</div>
                <div className="text-sm text-gray-600">Years experience</div>
              </div>
              <div>
                <div className="text-2xl font-extrabold text-[#162456]">
                  20+
                </div>
                <div className="text-sm text-gray-600">Aspirants trained</div>
              </div>
              <div>
                <div className="text-2xl font-extrabold text-[#162456]">
                  90%
                </div>
                <div className="text-sm text-gray-600">Satisfaction†</div>
              </div>
            </div>

            <p className="mt-4 text-xs text-gray-500">
              †Representative metric from feedback
            </p>
          </div>
        </section>

        {/* Curriculum Highlights / Timeline */}
        <section className="mt-12 bg-white rounded-2xl shadow-lg p-8">
          <h4 className="text-2xl font-bold text-[#162456]">
            Curriculum Highlights
          </h4>
          <p className="mt-2 text-gray-600">
            A quick look at the major topics and structure.
          </p>

          <ol className="mt-6 space-y-4 border-l-2 border-yellow-100 pl-6">
            <li>
              <div className="font-semibold text-[#162456]">
                Physical Chemistry - Core
              </div>
              <div className="text-sm text-gray-600">
                Thermodynamics, Kinetics, Electrochemistry, Chemical Kinetics
              </div>
            </li>
            <li>
              <div className="font-semibold text-[#162456]">
                Organic Chemistry - Concepts
              </div>
              <div className="text-sm text-gray-600">
                Reaction mechanisms, Named reactions, Synthesis strategies
              </div>
            </li>
            <li>
              <div className="font-semibold text-[#162456]">
                Inorganic Chemistry - Theory & MCQs
              </div>
              <div className="text-sm text-gray-600">
                Periodic trends, Coordination chemistry, Solid state
              </div>
            </li>
          </ol>
        </section>

        {/* Testimonials */}
        <section className="mt-12 grid md:grid-cols-3 gap-6">
          <div className="md:col-span-1 bg-[#162456] text-white rounded-2xl p-8 flex flex-col justify-between">
            <div>
              <h5 className="text-2xl font-bold">What students say</h5>
              <p className="mt-3 text-sm opacity-90">
                Real feedback from recent batches.
              </p>
            </div>

            <a
              href="#contact"
              className="mt-6 inline-block bg-yellow-100 text-[#162456] px-5 py-3 rounded-lg font-semibold"
            >
              Join a batch
            </a>
          </div>

          <div className="p-6 rounded-2xl bg-white shadow-lg">
            <div className="italic">
              “Sourabh sir helped me think clearly under exam pressure — the
              strategies worked.”
            </div>
            <div className="mt-4 font-semibold text-[#162456]">
              — A. Sharma, IIT JAM 2024
            </div>
          </div>

          <div className="p-6 rounded-2xl bg-white shadow-lg">
            <div className="italic">
              “The test series and doubt sessions were precise and timed — huge
              help.”
            </div>
            <div className="mt-4 font-semibold text-[#162456]">
              — R. Kapoor, GATE 2024
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="mt-12 bg-white rounded-2xl p-8 shadow-lg">
          <h4 className="text-2xl font-bold text-[#162456]">
            Frequently asked questions
          </h4>

          <div className="mt-6 grid md:grid-cols-2 gap-4">
            <details className="p-4 border rounded-lg">
              <summary className="font-semibold cursor-pointer">
                What exams do you prepare for?
              </summary>
              <p className="mt-2 text-sm text-gray-600">
                IIT JAM, JEE (chemistry), GATE, NEET (chemistry), NET.
              </p>
            </details>

            <details className="p-4 border rounded-lg">
              <summary className="font-semibold cursor-pointer">
                Do you offer recorded lectures?
              </summary>
              <p className="mt-2 text-sm text-gray-600">
                Yes — recordings for revision and missed classes.
              </p>
            </details>
          </div>
        </section>

        {/* CTA */}
        <section
          id="contact"
          className="my-12 rounded-2xl p-8 shadow-lg bg-[#162456] text-white"
        >
          <div className="max-w-4xl mx-auto text-center">
            <h4 className="text-3xl font-bold">
              Ready to level up your chemistry?
            </h4>
            <p className="mt-3 text-white/90">
              Schedule a free trial session or contact us for batch details.
            </p>

            <div className="mt-6 flex flex-col sm:flex-row gap-4 justify-center">
              <a className="bg-yellow-100 text-[#162456] px-6 py-3 rounded-lg font-semibold">
                Book Free Trial
              </a>
              <a className="border border-white/20 px-6 py-3 rounded-lg">
                Contact Us
              </a>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default About;
